(function () {
  'use strict';
  var dialog = document.querySelector('[data-checkout-choice]');
  if (!dialog || !dialog.showModal) return;
  var bundleId = Number(dialog.dataset.bundle), addonId = Number(dialog.dataset.addon);
  var root = dialog.dataset.root, checkbox = dialog.querySelector('[data-choice-addon]');
  var next = dialog.querySelector('[data-choice-continue]'), error = dialog.querySelector('[data-choice-error]');
  var cart = null, trigger = null, pending = false;
  var format = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: dialog.dataset.currency, maximumFractionDigits: 2, minimumFractionDigits: 0 });
  function money(cents) { return format.format(cents / 100); }
  function updateTotal() {
    var total = cart ? cart.total_price : Number(dialog.dataset.price);
    var hasBundle = cart && cart.items.some(function (i) { return i.variant_id === bundleId; });
    var hasAddon = cart && cart.items.some(function (i) { return i.variant_id === addonId; });
    if (cart && !hasBundle) total += Number(dialog.dataset.price);
    if (checkbox.checked && !hasAddon) total += Number(dialog.dataset.addonPrice);
    dialog.querySelector('[data-choice-total]').textContent = money(total);
    dialog.querySelector('[data-choice-button-price]').textContent = money(total);
  }
  async function json(url, options) {
    var response = await fetch(root + url, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, options));
    var value = await response.json();
    if (!response.ok) throw new Error(value.description || 'Unable to update your order. Please try again.');
    return value;
  }
  async function open(source) {
    trigger = source; error.hidden = true; cart = null; checkbox.checked = false; checkbox.disabled = false;
    document.querySelectorAll('dialog[open]').forEach(function (other) { if (other !== dialog) other.close(); });
    updateTotal(); dialog.showModal();
    try {
      cart = await json('cart.js');
      // Never skip adding the collection when a standalone workbook is already in the cart.
      var existingAddon = cart.items.find(function (i) { return i.variant_id === addonId; });
      var existingBundle = cart.items.some(function (i) { return i.variant_id === bundleId; });
      if (existingAddon && existingBundle) { dialog.close(); location.assign(root + 'checkout'); return; }
      if (existingAddon) {
        checkbox.checked = true;
        await json('cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: bundleId, quantity: 1 }] }) });
        cart = await json('cart.js');
        existingAddon = cart.items.find(function (i) { return i.variant_id === addonId; });
        if (existingAddon && existingAddon.final_price === Number(dialog.dataset.addonPrice)) { dialog.close(); location.assign(root + 'checkout'); return; }
        error.textContent = 'Please review your order in the cart before continuing.'; error.hidden = false;
      }
      updateTotal();
    } catch (e) { cart = null; }
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var variant = form.querySelector('[name="id"]');
    if (variant && Number(variant.value) === bundleId && /\/cart\/add/.test(form.action)) {
      event.preventDefault(); event.stopImmediatePropagation(); open(event.submitter || form); return;
    }
    // The regular cart remains a single explicit checkout step.
    if (event.submitter && event.submitter.name === 'checkout' && form.querySelector('[data-cart-bundle]')) {
      event.preventDefault(); event.stopImmediatePropagation(); open(event.submitter);
    }
  }, true);
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-journey-buy] a[href*="checkout"]');
    if (link) { event.preventDefault(); open(link); }
  });
  checkbox.addEventListener('change', updateTotal);
  dialog.querySelector('[data-choice-close]').addEventListener('click', function () { if (!pending) dialog.close(); });
  dialog.addEventListener('cancel', function (e) { if (pending) e.preventDefault(); });
  dialog.addEventListener('close', function () { if (trigger && trigger.focus) trigger.focus(); });
  next.addEventListener('click', async function () {
    if (pending) return;
    pending = true; next.disabled = true; checkbox.disabled = true; error.hidden = true;
    try {
      cart = await json('cart.js');
      var items = [];
      if (!cart.items.some(function (i) { return i.variant_id === bundleId; })) items.push({ id: bundleId, quantity: 1 });
      if (checkbox.checked && !cart.items.some(function (i) { return i.variant_id === addonId; })) items.push({ id: addonId, quantity: 1 });
      if (items.length) await json('cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) });
      cart = await json('cart.js');
      if (checkbox.checked) {
        var addon = cart.items.find(function (i) { return i.variant_id === addonId; });
        if (!addon || addon.final_price !== Number(dialog.dataset.addonPrice)) {
          // Do not take a buyer to payment at a higher companion price than promised.
          if (addon) await json('cart/change.js', { method: 'POST', body: JSON.stringify({ id: addon.key, quantity: 0 }) });
          checkbox.checked = false;
          cart = await json('cart.js'); updateTotal();
          throw new Error('The companion offer could not be applied. It has not been included. You can continue with your collection.');
        }
      }
      location.assign(root + 'checkout');
    } catch (e) {
      error.textContent = e.message || 'Please try again. Your order has not been placed.'; error.hidden = false;
      pending = false; next.disabled = false; checkbox.disabled = false;
    }
  });
})();
